import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ChangeLogoModal } from 'src/modules/features/admin/modals';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import {
  MyProfileModal,
  UsernameChangeModal,
} from 'src/modules/features/setting/modals';
import { AccountService } from 'src/modules/features/setting/services';
import { AuthenticationService } from 'src/modules/core/services';
import { CommonServices } from 'src/modules/shared';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-agent-profile-details',
  templateUrl: './profile-detail.component.html',
  styleUrls: ['./profile-detail.component.scss'],
})
export class ProfileAgentDetailsComponent implements OnInit {
  user: any;
  organization: any;
  pending: boolean;
  error: any;
  success: any;
  image = 'assets/avatar/1.jpg';
  baseUrl: string = environment.API_SERVER;
  userName;
  email;

  constructor(
    private authService: AuthenticationService,
    private modalService: SuiModalService,
    private location: Location,
    private accountSvc: AccountService
  ) {
    this.user = JSON.parse(window.localStorage.getItem('user'));
    this.userName = this.user.username;
    this.email = this.user.appUserEmail;
    if (this.user && this.user.image) {
      this.image = `${
        this.baseUrl
      }/public/image/?media=${this.user.image.replace(/\\/g, '/')}`;
    }
    // this.authService.user.subscribe((res) => {
    // 	this.user = res;
    // 	if (this.user && this.user.image) {
    // 		this.image = `${this.baseUrl}/public/image/?media=${this.user.image}`;
    // 	}
    // });
  }
  uploadImage(event) {
    //     this.pending = true;
    //     this.error = false;
    // 	this.authService.uploadUserPhotoBase({ appUserId: this.user.appUserId, body: event })
    // 	.subscribe(res => {
    //         console.log(res);
    //         this.user.image = res['data'];
    //         window.localStorage.setItem('user', JSON.stringify(Object.assign({}, this.user)));
    //         setTimeout(() => {
    //             this.pending = false;
    //             this.success = 'Photo updated successfully';
    //             this.sharedService.setRefreshStorage('');
    //         }, 1000);
    //     }, error => {
    //         this.pending = false;
    //         this.error = error.error;
    //     });
  }
  edit() {
    this.modalService
      .open(
        new MyProfileModal('Edit My Profile', this.user, true, ModalSize.Tiny)
      )
      .onApprove((updated: any) => {
        this.user = { ...this.user, ...updated };
      })
      .onDeny(() => {});
  }
  username(isUsername) {
    console.log(isUsername);
    this.modalService
      .open(
        new UsernameChangeModal(
          'Edit My Profile',
          this.user,
          isUsername,
          ModalSize.Tiny
        )
      )
      .onApprove((updated: any) => {
        console.log(updated);
        this.validateEmail(updated.usernameOrEmail);
        this.user = { ...this.user, ...{ username: updated.username } };
      })
      .onDeny(() => {});
  }
  validateEmail(emailAdress) {
    let existing = JSON.parse(window.localStorage.getItem('user'));
    let regexEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (emailAdress.match(regexEmail)) {
      this.email = emailAdress;
      existing.appUserEmail = emailAdress;
    } else {
      this.userName = emailAdress;
      existing.username = emailAdress;
    }
    localStorage.setItem('user', JSON.stringify(existing));
  }

  changeImage() {
    this.modalService
      .open(new ChangeLogoModal('Edit Logo', this.user, ModalSize.Tiny))
      .onApprove((file: any) => {
        function getBase64(file) {
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = function () {
            console.log(reader.result);
          };
          reader.onerror = function (error) {
            console.log('Error: ', error);
          };
        }
        // let payload = getBase64(file);
        this.pending = true;
        const formData = new FormData();
        formData.append('file', file);
        this.accountSvc
          .uploadUserPhoto({ appUserId: this.user.appUserId, body: formData })
          .subscribe(
            (res) => {
              this.pending = false;
              this.success = 'Profile updated successfully';
              this.image = `${this.baseUrl}/public/image/?media=${res[
                'data'
              ].replace(/\\/g, '/')}`;
              this.user.image = res['data'];
              window.localStorage.setItem(
                'user',
                JSON.stringify(Object.assign({}, this.user))
              );
              this.authService.setRefreshStorage(res);
              window.location.reload();
            },
            (error) => {
              this.pending = false;
              this.error = error.error.errorMessage
                ? error.error.errorMessage
                : error.error
                ? error.error
                : error;
            }
          );
      })
      .onDeny(() => {});
  }
  goBack() {
    this.location.back();
  }
  ngOnInit(): void {}
  editUsername() {}
  editEmail() {}
}
